<template>
  <div class="form-group" v-if="fbinvisible != 'true'">
    <div class="row">
      <div class="col-form-label col-sm-12" v-if="fbhidelabel !== 'true'">
        
        <label><b style="color: red;" v-if="fbrequired == 'true'">*</b>{{fbsupportmultiplelanguages? $helper.getWord(fblabel) :fblabel || '&nbsp;' }}</label>
      </div>

      <div class="col-sm-12">
        <div class="form-check-wrapper" :class="{ invalid: !isValid }">
          <div ref="fboptions"  v-for="option in fboptions" class="form-check"  :key="option.Key">
            <label class="form-check-label">
              <input type="checkbox" class="form-check-input-styled" :name="id" :value="option.Value" @change="dataChanged" :checked="option.Key === d" :disabled="checkReadonly(isedit, fbreadonly)"/>
              {{ option.Key }}
            </label>
          </div>
        </div>
        <!-- <input v-if="fbreadonly == 'true'" type="text" class="form-control" :value="valueText" >
        <label v-if="isValid === false" id="basic-error" class="validation-invalid-label" for="basic">{{ $t('ui.SYS00016') }}</label> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CheckBoxes',
  props: ['id', 'fbsupportmultiplelanguages','fblabel', 'value', 'fbvalue', 'fboptions', 'fbreadonly', 'fbrequired', 'labelwidth', 'fbhidelabel', 'isedit', "fbinvisible"],
  data () {
    return {
      d: null,
      isValid: true,
      checkValue: []
    }
  },
  mounted () {
    this.$emit('input', this.fbvalue, this);  //vue componenet value
    if(this.value != null){
      $(this.$el).find(':checkbox[value="' + this.value + '"]').prop('checked', true)
    }
  },
  methods: {
    checkReadonly(isedit, fbreadonly) {
      let readonly = true;
      if (isedit) {
        if (fbreadonly == "true") {
          readonly = true;
        } else {
          readonly = false;
        }
      } else {
        readonly = true;
      }

      return readonly;
    },
    dataChanged (e) {
        var vm = this;
        vm.checkValue = [];
        var temp = $(vm.$el).find('input:checked');
        console.log(temp);
        $.each(temp, function(key, value){
            vm.checkValue.push($(value).val());
        });
        //this.d = $(e.target).val()

      this.$emit('input', vm.checkValue, this)
    }
  },
//   watch: {
//     value: function (val) {
//       this.d = val
//       $(this.$el).find(':checkbox').prop('checked', false);
//       //console.log($(this.$el).find(':checkbox'));


//       $(this.$el).find(':checkbox[value="' + val + '"]').prop('checked', true)

//     }
//   }
}
</script>
